export default __webpack_public_path__ + "static/media/icon_overview.45b5115a.svg";